import BaseModel from '../core/BaseModel'
export default class DashboardModel extends BaseModel {
    constructor() {
        super({ 
                name: "dashboard",
                tableName: 'kind', 
                label: "Dashboard",
                display_key: 'name',
                default_order: { key: 'updated_at', direction: 'asc' }
            },  
            {
                id: { 
                    name: 'id', 
                    type: "Uuid", 
                    label: 'ID', 
                    primaryKey: true, 
                    display: false
                },
                name: {
                    name: 'name',
                    type: 'String',
                    class: 'center',
                    label: 'Loại cua',
                    sortable: false,
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                },
                number: {
                    name: 'number',
                    type: 'String',
                    class: 'center',
                    label: 'Số con hiện tại',
                    computed: (data) => {
                        data.number = "";
                    }
                },
                // import_weight: {
                //     name: 'import_weight',
                //     type: 'String',
                //     class: 'center',
                //     label: 'Tổng trọng lượng nhập (kg)',
                //     computed: (data) => {
                //         data.import_weight = "";
                //     }
                // },
                estimate_weight: {
                    name: 'estimate_weight',
                    type: 'String',
                    class: 'center',
                    label: 'Tổng trọng ước tính (kg)',
                    computed: (data) => {
                        data.estimate_weight = "";
                    }
                },
                weight: {
                    name: 'weight',
                    display: false
                },
                growth: {
                    name: 'growth',
                    display: false
                },
                type: {
                    refs: 'type {id name}',
                    display: false
                },
                type_id: {
                    name: 'type_id',
                    display: false
                },
                obj_boxes: {
                    refs: 'obj_boxes {weight date_growth unit_id total unit {id farm_id farm {id name}}}',
                    display: false
                },
            },
        )
    }

}